import { useEffect, useState } from 'react';
import type { PropsWithChildren } from 'react';

import FlagProvider from '@unleash/proxy-client-react';
// eslint-disable-next-line import/no-unresolved
import Navbar from 'navbar/components';

import { CenteredLoadingIndicator } from '@storebrand-digital/bank-foundation-components';

import { isE2E, isWebView } from '@app/utils';
import ErrorPageView from '@features/ErrorPageView';
import auth from '@utils/auth';
import { initFMS } from '@utils/fms';
import { initMonitoring, logError } from '@utils/monitoring';

import getUnleashConfig from './unleash';

export default function InitProvider({ children }: PropsWithChildren) {
  const [initialized, setInitialized] = useState<'error' | 'success'>();

  useEffect(() => {
    async function init() {
      initMonitoring();
      await initFMS();
      if (!isE2E) {
        await auth.init();
        await auth.login();
      }
    }

    init()
      .then(() => setInitialized('success'))
      .catch((e) => {
        logError(e);
        setInitialized('error');
      });
  }, []);

  if (initialized === 'error') {
    return <ErrorPageView />;
  }

  return initialized === 'success' && (auth.authenticated || isE2E) ? (
    <FlagProvider config={getUnleashConfig(auth)}>
      {!isWebView && <Navbar />}
      {children}
    </FlagProvider>
  ) : (
    <CenteredLoadingIndicator isFixed />
  );
}
